var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubesInBag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67 90",
    width: 67,
    height: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#004137;stroke-width:1.5}.b{fill:#9e8959;stroke:#9e8959;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.7}.c{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.7}.d{fill:#a971b0;stroke:#a971b0;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.7}.e{fill:none;stroke:#004137;stroke-width:1.7}.f{fill:none;stroke:#9e8959;stroke-width:1.7}.g{fill:none;stroke:#a971b0;stroke-width:1.7}.h{fill:#004137}.i{fill:none;stroke:#000;stroke-width:1.5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0.8 13.3l64.5-0.1v69.1c0 3.8-3.1 6.8-6.9 6.8h-50.8c-3.8 0-6.9-3-6.9-6.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m30.5 21.3v-12.7c0.1-1.8-0.9-4.2-0.9-6 0-1.7-2-1.6-2-1.6h-5.9-0.9-5.9c0 0-2-0.1-2 1.6 0 1.8-1 4.2-0.9 6v12.7c0 0-0.3 2.5 2 2.5h6.8c0.6 0 0.9 0 0.9 0h6.8c2.3 0 2-2.5 2-2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m21.3 4.5v15.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m16.4 6.4v13.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m26.1 6.4v13.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m54.5 21.3v-12.7c0.1-1.8-0.9-4.2-0.9-6 0-1.7-2-1.6-2-1.6h-5.9-0.9-5.9c0 0-2-0.1-2 1.6 0 1.8-1 4.2-0.9 6v12.7c0 0-0.3 2.5 2 2.5h6.8c0.6 0 0.9 0 0.9 0h6.8c2.3 0 2-2.5 2-2.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m45.3 4.5v15.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m40.4 6.4v13.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m50.1 6.4v13.7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m14.5 24.4v15"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m38.5 24.4v15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m27.9 24.4v15"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m51.9 24.4v15"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m18.7 39.4v-10h8.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m42.7 39.4v-10h8.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m26.9 33.5v-0.8h-5.9v0.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m26.9 34.3v-0.4h-5.9v0.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m26.9 35.5v-0.4h-5.9v0.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m26.9 37.4v-0.3h-5.9v0.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m26.9 39v-0.4h-5.9v0.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m50.9 33.5v-0.8h-5.9v0.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m50.9 34.3v-0.4h-5.9v0.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m50.9 35.5v-0.4h-5.9v0.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m50.9 37.4v-0.3h-5.9v0.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m50.9 39v-0.4h-5.9v0.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "i",
    d: "m1.3 39.3h63.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubesInBag);
export default __webpack_public_path__ + "static/media/tubes-in-bag.ecaa58d1beae9407a8e6e16e9fbb8821.svg";
export { ForwardRef as ReactComponent };